const SortFunctions = ({ details, setSortState, setDetails }) => {
  const handleAscSort = (sortProperty) => {

    const sortedAsc = [...details.slice(1)].sort((a, b) => {
      return a[sortProperty] - b[sortProperty];
    });

    const updatedAsc = [details[0], ...sortedAsc];
    setSortState({ key: sortProperty, direction: 'asc' });
    setDetails(updatedAsc);
  };

  const handleDesSort = (sortProperty) => {
    console.log(`Sorting Descending by ${sortProperty}`);

    const sortedDes = [...details.slice(1)].sort((a, b) => {
      return (b[sortProperty] ?? 0) - (a[sortProperty] ?? 0);
    });

    const updatedDes = [details[0], ...sortedDes];
    setSortState({ key: sortProperty, direction: 'desc' });
    setDetails(updatedDes);
  };

  return {
    handleAscSort,
    handleDesSort,
  };
};

export default SortFunctions;
